<template lang="pug">
div
  .row
    .col-12
      b-form-group(:label="$t('ui.marquee')")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(width="%")
                  span(:title="$t('ui.content')") {{ $t('ui.content') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
            tbody.clusterize-content
              tr(v-if="marquee.length == 0")
                td(:colspan="4").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in marquee")
                td
                  span(:title="item.marquee_content") {{ item.marquee_content }}
                  .float-right
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")
                td.text-right
                  span(:title="item.modified_by") {{ item.modified_by }}
                td.text-right
                  span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") }}

  ul#cmstab.nav.nav-tabs(role='tablist')
    template(v-if="showActionButton('cms')")
      li.nav-item(@click="refresh('announcementbanner')")
        a#announcementbanner-tab.nav-link(:class="{ 'active': currTab == 'announcementbanner' }" data-toggle='tab' href='#announcementbanner-content' role='tab' aria-controls='announcementbanner' aria-selected='false') {{ $t("ui.announcement_banner") }}
      li.nav-item(@click="refresh('promotionbanner')")
        a#promotionbanner-tab.nav-link(:class="{ 'active': currTab == 'promotionbanner' }" data-toggle='tab' href='#promotionbanner-content' role='tab' aria-controls='promotionbanner' aria-selected='false') {{ $t("ui.promotion_banner") }}
      li.nav-item(@click="refresh('slidebanner')")
        a#slidebanner-tab.nav-link(:class="{ 'active': currTab == 'slidebanner' }" data-toggle='tab' href='#slidebanner-content' role='tab' aria-controls='slidebanner' aria-selected='false') {{ $t("ui.slide_banner") }}
      li.nav-item(@click="refresh('seopage')")
        a#seopage-tab.nav-link(:class="{ 'active': currTab == 'seopage' }" data-toggle='tab' href='#seopage-content' role='tab' aria-controls='seopage' aria-selected='false') {{ $t("ui.seo_page") }}
      li.nav-item(@click="refresh('siteinfo')")
        a#siteinfo-tab.nav-link(:class="{ 'active': currTab == 'siteinfo' }" data-toggle='tab' href='#siteinfo-content' role='tab' aria-controls='siteinfo' aria-selected='false') {{ $t("ui.site_info") }}
      li.nav-item(@click="refresh('socialaccount')")
        a#socialaccount-tab.nav-link(:class="{ 'active': currTab == 'socialaccount' }" data-toggle='tab' href='#socialaccount-content' role='tab' aria-controls='socialaccount' aria-selected='false') {{ $t("ui.social_account") }}
      li.nav-item(@click="refresh('livechat')")
        a#livechat-tab.nav-link(:class="{ 'active': currTab == 'livechat' }" data-toggle='tab' href='#livechat-content' role='tab' aria-controls='livechat' aria-selected='false') {{ $t("ui.livechat") }}
      li.nav-item(@click="refresh('partners')")
        a#partners-tab.nav-link(:class="{ 'active': currTab == 'partners' }" data-toggle='tab' href='#partners-content' role='tab' aria-controls='partners' aria-selected='false') {{ $t("ui.partners") }}
      li.nav-item(@click="refresh('leaderboardbanner')")
        a#leaderboardbanner-tab.nav-link(:class="{ 'active': currTab == 'leaderboardbanner' }" data-toggle='tab' href='#leaderboardbanner-content' role='tab' aria-controls='leaderboardbanner' aria-selected='false') {{ $t("ui.leaderboard_banner") }}
      li.nav-item(@click="refresh('referralbanner')")
        a#referralbanner-tab.nav-link(:class="{ 'active': currTab == 'referralbanner' }" data-toggle='tab' href='#referralbanner-content' role='tab' aria-controls='referralbanner' aria-selected='false') {{ $t("ui.referral_banner") }}
      li.nav-item(@click="refresh('news')")
        a#news-tab.nav-link(:class="{ 'active': currTab == 'news' }" data-toggle='tab' href='#news-content' role='tab' aria-controls='news' aria-selected='false') {{ $t("ui.news") }}
    //- template(v-if="showActionButton('aiassistant')")
    //-   li.nav-item(@click="refresh('aiassistant')")
    //-     a#aiassistant-tab.nav-link(:class="{ 'active': currTab == 'aiassistant' }" data-toggle='tab' href='#aiassistant-content' role='tab' aria-controls='aiassistant' aria-selected='false') {{ $t("ui.ai_assistant") }}

  #cmstabcontent.tab-content.tab-bordered
    template(v-if="showActionButton('cms')")
      #announcementbanner-content.tab-pane(:class="{ 'active show': currTab == 'announcementbanner' }" role='tabpanel' aria-labelledby='announcementbanner-tab')
        announcementBannerTab(ref="announcementBannerTab" :currTab="currTab")
      #promotionbanner-content.tab-pane.fade(:class="{ 'active show': currTab == 'promotionbanner' }" role='tabpanel' aria-labelledby='promotionbanner-tab')
        promotionBannerTab(ref="promotionBannerTab" :currTab="currTab")
      #slidebanner-content.tab-pane.fade(:class="{ 'active show': currTab == 'slidebanner' }" role='tabpanel' aria-labelledby='slidebanner-tab')
        slideBannerTab(ref="slideBannerTab" :currTab="currTab")
      #seopage-content.tab-pane.fade(:class="{ 'active show': currTab == 'seopage' }" role='tabpanel' aria-labelledby='seopage-tab')
        seoPageTab(ref="seoPageTab" :currTab="currTab")
      #siteinfo-content.tab-pane.fade(:class="{ 'active show': currTab == 'siteinfo' }" role='tabpanel' aria-labelledby='siteinfo-tab')
        siteInfoTab(ref="siteInfoTab")
      #socialaccount-content.tab-pane.fade(:class="{ 'active show': currTab == 'socialaccount' }" role='tabpanel' aria-labelledby='socialaccount-tab')
        socialAccountTab(ref="socialAccountTab")
      #livechat-content.tab-pane.fade(:class="{ 'active show': currTab == 'livechat' }" role='tabpanel' aria-labelledby='livechat-tab')
        livechatTab(ref="livechatTab")
      #partners-content.tab-pane.fade(:class="{ 'active show': currTab == 'partners' }" role='tabpanel' aria-labelledby='partners-tab')
        partnersTab(ref="partnersTab")
      #leaderboardbanner-content.tab-pane.fade(:class="{ 'active show': currTab == 'leaderboardbanner' }" role='tabpanel' aria-labelledby='leaderboardbanner-tab')
        leaderboardBannerTab(ref="leaderboardBannerTab" :currTab="currTab")
      #referralbanner-content.tab-pane.fade(:class="{ 'active show': currTab == 'referralbanner' }" role='tabpanel' aria-labelledby='referralbanner-tab')
        referralBannerTab(ref="referralBannerTab" :currTab="currTab")
      #news-content.tab-pane.fade(:class="{ 'active show': currTab == 'news' }" role='tabpanel' aria-labelledby='news-tab')
        newsTab(ref="newsTab" :currTab="currTab")
    //- template(v-if="showActionButton('aiassistant')")
    //-   #aiassistant-content.tab-pane.fade(:class="{ 'active show': currTab == 'aiassistant' }" role='tabpanel' aria-labelledby='aiassistant-tab')
    //-     aiAssistantTab(ref="aiAssistantTab")
  editmarquee(ref="editmarquee" :item="item" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import announcementBannerTab from "@/components/cmsTab/announcementBannerTab.vue";
import promotionBannerTab from "@/components/cmsTab/promotionBannerTab.vue";
import slideBannerTab from "@/components/cmsTab/slideBannerTab.vue";
import seoPageTab from "@/components/cmsTab/seoPageTab.vue";
import siteInfoTab from "@/components/cmsTab/siteInfoTab.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import editmarquee from "@/components/cmsTab/editMarquee.vue";
import socialAccountTab from "@/components/operatorTab/socialAccountTab.vue";
import livechatTab from "@/components/cmsTab/livechatTab.vue";
import partnersTab from "@/components/cmsTab/partnersTab.vue";
import aiAssistantTab from "@/components/cmsTab/aiAssistantTab.vue";
import leaderboardBannerTab from "@/components/cmsTab/leaderboardBannerTab.vue";
import referralBannerTab from "@/components/cmsTab/referralBannerTab.vue";
import newsTab from "@/components/cmsTab/newsTab.vue";

export default {
  components: {
    SubmitButton,
    announcementBannerTab,
    promotionBannerTab,
    slideBannerTab,
    seoPageTab,
    siteInfoTab,
    editmarquee,
    socialAccountTab,
    livechatTab,
    partnersTab,
    aiAssistantTab,
    leaderboardBannerTab,
    referralBannerTab,
    newsTab,
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    marquee: [],
    item: null,
    currTab: 'announcementbanner'
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    }
  },
  mounted: function() {  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      switch(tab) {
        case 'announcementbanner':
          // this.currTab = 'announcementbanner'
          // if(this.$refs.announcementBannerTab) {
          //   this.$refs.announcementBannerTab.refresh();
          // }
          this.tabChecking();
          break
        case 'promotionbanner':
          this.currTab = 'promotionbanner'
          if(this.$refs.promotionBannerTab) {
            this.$refs.promotionBannerTab.refresh();
          }
          break
        case 'slidebanner':
          this.currTab = 'slidebanner'
          if(this.$refs.slideBannerTab) {
            this.$refs.slideBannerTab.refresh();
          }
          break
        case 'seopage':
          this.currTab = 'seopage'
          if(this.$refs.seoPageTab) {
            this.$refs.seoPageTab.refresh();
          }
          break
        case 'siteinfo':
          this.currTab = 'siteinfo'
          if(this.$refs.siteInfoTab) {
            this.$refs.siteInfoTab.refresh();
          }
          break
        case 'socialaccount':
          this.currTab = 'socialaccount'
          if(this.$refs.socialAccountTab) {
            this.$refs.socialAccountTab.refresh();
          }
          break
        case 'livechat':
          this.currTab = 'livechat'
          if(this.$refs.livechatTab) {
            this.$refs.livechatTab.refresh();
          }
          break
        case 'partners':
          this.currTab = 'partners'
          if(this.$refs.partnersTab) {
            this.$refs.partnersTab.refresh();
          }
          break
        case 'leaderboardbanner':
          this.currTab = 'leaderboardbanner'
          if(this.$refs.leaderboardBannerTab) {
            this.$refs.leaderboardBannerTab.refresh();
          }
          break
        case 'referralbanner':
          this.currTab = 'referralbanner'
          if(this.$refs.referralBannerTab) {
            this.$refs.referralBannerTab.refresh();
          }
          break
        case 'news':
          this.currTab = 'news'
          if(this.$refs.newsTab) {
            this.$refs.newsTab.refresh();
          }
          break
        // case 'aiassistant':
        //   this.currTab = 'aiassistant'
        //   if(this.$refs.aiAssistantTab) {
        //     this.$refs.aiAssistantTab.refresh();
        //   }
        //   break
      }

      this.getMarquee()
      this.getThemeCode()
    },
    tabChecking() {
      if(this.showActionButton('cms')) {
        this.currTab = 'announcementbanner'
        this.$nextTick(() => {
          if(this.$refs.announcementBannerTab) {
            this.$refs.announcementBannerTab.refresh();
          }
        });
      } else {
        this.currTab = 'aiassistant'
        this.$nextTick(() => {
          if(this.$refs.aiAssistantTab) {
            this.$refs.aiAssistantTab.refresh();
          }
        });
      }
    },
    getMarquee: function() {
      let url = config.marqueeGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // console.log(response)
                this.marquee = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getThemeCode: function() {
      let url = config.getThemeCodeUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.dt.length > 0) {
                  this.$store.dispatch("user/setSelectedTheme", response.data.dt[0].theme_code);
                } else {
                  this.themeCode = ""
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEdit(e) {
      this.item = e;
      this.$refs.editmarquee.$refs.editMarquee.show();
    },
    afterEdit() {
      this.getMarquee();
      this.$helpers.showDialog(this.$t("ui.edit_marquee"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>